import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Layout from "hocs/layouts/Layout";
import Home from "containers/pages/Home";
import Biblia from "containers/pages/Bible";
import Search from "containers/pages/Search";
import Libros from "containers/pages/Books";
import PlanLectura from "containers/pages/ReadingPlan";
import BookChapters from "components/bible/BookChapters";
import VersesDisplay from "components/bible/VersesDisplay";
import Error404 from "containers/errors/Error404";
import ScrollToTop from "components/navigation/ScrollToTop";

import useGAPageViews from "./hooks/useGAPageViews";

const MEASUREMENT_ID = "G-ZY3G67XJB2";

function GAListener() {
  useGAPageViews(MEASUREMENT_ID);
  return null;
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <GAListener />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="biblia" element={<Biblia />} />
            <Route path="buscador" element={<Search />} />
            <Route path="libros" element={<Libros />} />
            <Route path="planlectura" element={<PlanLectura />} />
            <Route path="bible/book/:bookId" element={<BookChapters />} />
            <Route
              path="bible/book/:bookId/chapter/:chapterNumber"
              element={<VersesDisplay />}
            />
            <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
